import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { createPinia } from "pinia";
import axios from "axios";

/* eslint-disable */
axios.defaults.baseURL = "https://dev.eglobalpro.com/public/front_lhenaff/dist/";
loadFonts();

createApp(App).use(createPinia()).use(router).use(vuetify).mount("#app");
